
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upcoming-cricket-schedule",
      function () {
        return require("private-next-pages/upcoming-cricket-schedule/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upcoming-cricket-schedule"])
      });
    }
  